import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { t as translate } from "@/lib/i18n";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("rl_lang") || "id");
  const [brand, setBrand] = useState(null);
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("rl_cart") || "[]"));

  useEffect(() => {
    api.get("/config/brand").then(({ data }) => {
      setBrand(data);
      if (data?.seo?.title) {
        document.title = data.seo.title;
      }
      if (data?.seo?.description) {
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) metaDesc.setAttribute("content", data.seo.description);
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute("content", data.seo.description);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => { localStorage.setItem("rl_lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("rl_cart", JSON.stringify(cart)); }, [cart]);

  const toggleLang = () => setLang((l) => (l === "id" ? "en" : "id"));
  const t = (key) => translate(key, lang);

  const addToCart = (product) => {
    setCart((c) => {
      if (c.find((x) => x.id === product.id)) return c;
      return [...c, { id: product.id, title: product.title, price: product.price,
        photo: (product.photos || [])[0], condition: product.condition,
        store: product.store?.name, cod_enabled: !!product.cod_enabled, quantity: 1 }];
    });
  };
  const removeFromCart = (id) => setCart((c) => c.filter((x) => x.id !== id));
  const clearCart = () => setCart([]);

  return (
    <AppCtx.Provider value={{ lang, setLang, toggleLang, t, brand, cart, addToCart, removeFromCart, clearCart }}>
      {children}
    </AppCtx.Provider>
  );
}
